import { CovidNewStatistics, CovidStatistics } from 'src/app/interfaces/map.interface';
import { SpecificStatistic } from 'src/app/swagger-api/model/specificStatistic';
import { StatisticType } from 'src/app/swagger-api/model/statisticType';
import { MapFilters } from '../map.enum';

export type MapStatisticsTabsLookup = { [key: string]: string[] };

export type MapStatisticsIconsLookup = { [key: string]: MapStatisticsIconConfig };

export interface MapStatisticsIcon {
  path: string;
  class: string;
}

export interface MapStatisticsIconConfig {
  title: string[];
  icon: MapStatisticsIcon;
}

export type OverallStatisticType = StatisticType | MapFilters.COVID;

export const OverallStatistic = {
  ...StatisticType,
  [MapFilters.COVID]: MapFilters.COVID,
};

export type OverallSpecificStatistic = SpecificStatistic | CovidStatistics | CovidNewStatistics;
